import { render, staticRenderFns } from "./NotIB.vue?vue&type=template&id=865c7306&scoped=true&"
import script from "./NotIB.vue?vue&type=script&lang=js&"
export * from "./NotIB.vue?vue&type=script&lang=js&"
import style0 from "./NotIB.vue?vue&type=style&index=0&id=865c7306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865c7306",
  null
  
)

export default component.exports